/* ══════════════════════════════════════════════════════
   RedEvidence — Animations & Interactions
   GSAP ScrollTrigger + Hero Timeline + Redacted Reveal
   ══════════════════════════════════════════════════════ */

// Always start at the top on page load/reload
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
window.scrollTo(0, 0);

gsap.registerPlugin(ScrollTrigger);

// ── PRELOADER ── (hero entrance handled by CSS animations in redevidence.css)
window.addEventListener('load', () => {
  const preloader = document.getElementById('preloader');
  if (!preloader) return;
  const delay = preloader.classList.contains('preloader-minimal') ? 400 : 2200;
  setTimeout(() => preloader.classList.add('hidden'), delay);
});

// ── Wait for DOM before querying elements ──
document.addEventListener('DOMContentLoaded', () => {

  // ── GSAP SCROLL REVEALS ──
  document.querySelectorAll('[data-gsap]').forEach(el => {
    const d = parseFloat(el.getAttribute('data-gsap-delay') || 0);
    gsap.fromTo(el,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 0.9, delay: d, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 88%', once: true }
      }
    );
  });

  // ── HERO PARALLAX ──
  gsap.to('#heroContent', {
    y: 150, opacity: 0, ease: 'none',
    scrollTrigger: { trigger: '.re-hero', start: 'top top', end: 'bottom top', scrub: true }
  });

  // ── REDACTED REVEAL ──
  ScrollTrigger.create({
    trigger: '#redactedSection',
    start: 'top 60%',
    once: true,
    onEnter: () => {
      const els = document.querySelectorAll('[data-reveal]');
      els.forEach((el, i) => {
        setTimeout(() => el.classList.add('revealed'), 300 + i * 250);
      });
      setTimeout(() => {
        const stamp = document.getElementById('redactedStamp');
        if (stamp) stamp.classList.add('visible');
      }, 300 + els.length * 250 + 500);
    }
  });

  // ── PARTICLES (deferred after LCP) ──
  requestAnimationFrame(() => {
    setTimeout(() => {
      const pc = document.getElementById('particles');
      if (pc) {
        for (let i = 0; i < 20; i++) {
          const p = document.createElement('div');
          p.className = 'particle';
          p.style.left = Math.random() * 100 + '%';
          p.style.animationDuration = (10 + Math.random() * 15) + 's';
          p.style.animationDelay = Math.random() * 12 + 's';
          pc.appendChild(p);
        }
      }
    }, 2000);
  });

  // ── NAV SCROLL ──
  window.addEventListener('scroll', () => {
    const nav = document.getElementById('mainNav');
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });

  // ── HAMBURGER ──
  const hb = document.getElementById('hamburger');
  const mm = document.getElementById('mobileMenu');
  if (hb && mm) {
    let mo = false;
    const closeMenu = () => {
      mo = false;
      hb.classList.remove('open');
      mm.classList.remove('open');
      document.body.style.overflow = '';
    };
    hb.addEventListener('click', () => {
      mo = !mo;
      hb.classList.toggle('open', mo);
      mm.classList.toggle('open', mo);
      document.body.style.overflow = mo ? 'hidden' : '';
    });
    mm.addEventListener('click', e => {
      if (e.target === mm) closeMenu();
    });
    document.querySelectorAll('.mobile-menu a').forEach(a =>
      a.addEventListener('click', closeMenu)
    );
  }

  // ── SMOOTH SCROLL ──
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      e.preventDefault();
      const t = document.querySelector(a.getAttribute('href'));
      if (t) {
        const y = t.getBoundingClientRect().top + window.pageYOffset - 60;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  });

  // ── EVIDENCE DOTS ──
  const es = document.getElementById('evidenceScroll');
  const dots = document.querySelectorAll('.evidence-dot');
  if (es && dots.length) {
    es.addEventListener('scroll', () => {
      const item = es.querySelector('.evidence-item');
      if (!item) return;
      const iw = item.offsetWidth + 16;
      const ai = Math.round(es.scrollLeft / iw);
      dots.forEach((d, i) => d.classList.toggle('active', i === ai));
    }, { passive: true });
  }

  // ── EVIDENCE FLIP ──
  document.querySelectorAll('.evidence-card').forEach(card => {
    card.addEventListener('click', () => card.classList.toggle('flipped'));
  });

  // ── FAQ TOGGLE ──
  document.querySelectorAll('.faq-question').forEach(q => {
    q.addEventListener('click', () => {
      q.parentElement.classList.toggle('open');
    });
  });

  // ── LENA DEMO SCROLL TRIGGER ──
  ScrollTrigger.create({
    trigger: '#lena',
    start: 'top 60%',
    once: true,
    onEnter: () => {
      const m = document.querySelector('[data-demo="0"]');
      if (m) m.classList.add('visible');
    }
  });

  // ── STEP ICON DRAW ──
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.step-icon svg path, .step-icon svg rect, .step-icon svg circle, .step-icon svg polyline').forEach(el => {
      try {
        const len = el.getTotalLength ? el.getTotalLength() : 0;
        if (len > 0) {
          el.style.strokeDasharray = len;
          el.style.strokeDashoffset = len;
        }
      } catch(e) {}
    });

    ScrollTrigger.create({
      trigger: '#how',
      start: 'top 70%',
      once: true,
      onEnter: () => {
        gsap.to('.step-icon svg path, .step-icon svg rect, .step-icon svg circle, .step-icon svg polyline', {
          strokeDashoffset: 0, duration: 1.2, ease: 'power2.out', stagger: 0.08
        });
      }
    });

    // ── QUOTE ENTRANCE ──
    gsap.fromTo('.quote-mark', { scale: 0.5, opacity: 0 }, {
      scale: 1, opacity: 1, duration: 0.8, ease: 'back.out(1.7)',
      scrollTrigger: { trigger: '.quote-section', start: 'top 70%', once: true }
    });
  }

  // ── LENA DEMO CHIPS ──
  window.demoAsk = function(chip, question, answer) {
    chip.style.opacity = '.3';
    chip.style.pointerEvents = 'none';
    const body = document.getElementById('lenaBody');
    if (!body) return;
    // Add user message
    const um = document.createElement('div');
    um.className = 'chat-msg user';
    um.textContent = question;
    body.appendChild(um);
    requestAnimationFrame(() => { um.classList.add('visible'); body.scrollTop = body.scrollHeight; });
    // Typing indicator
    const ti = document.createElement('div');
    ti.className = 'chat-typing';
    ti.innerHTML = '<div class="typing-dot"></div><div class="typing-dot"></div><div class="typing-dot"></div>';
    body.appendChild(ti);
    requestAnimationFrame(() => { ti.classList.add('visible'); body.scrollTop = body.scrollHeight; });
    // LENA reply
    setTimeout(() => {
      ti.remove();
      const lm = document.createElement('div');
      lm.className = 'chat-msg lena';
      lm.textContent = answer;
      body.appendChild(lm);
      requestAnimationFrame(() => { lm.classList.add('visible'); body.scrollTop = body.scrollHeight; });
    }, 1200 + Math.random() * 800);
  };

  // ── STICKY BOTTOM BAR ──
  const stickyBar = document.getElementById('stickyBar');
  const heroCtaEl = document.getElementById('heroCta');
  if (stickyBar && heroCtaEl) {
    const stickyObs = new IntersectionObserver(([e]) => {
      stickyBar.classList.toggle('visible', !e.isIntersecting);
    }, { threshold: 0 });
    stickyObs.observe(heroCtaEl);
  }

  // ── EXIT INTENT (Desktop: mouseleave, Mobile: scroll-up + timer) ──
  let exitShown = false;
  function showExitPopup() {
    // Nie im Kauf-Flow: Produktseiten + Warenkorb bleiben popup-frei (Paid-Traffic-Strecke)
    if (/^\/(products\/|cart)/.test(location.pathname)) return;
    if (exitShown || sessionStorage.getItem('re_exit_dismissed')) return;
    exitShown = true;
    const popup = document.getElementById('exitPopup');
    if (popup) popup.classList.add('visible');
  }

  // Desktop: mouse leaves viewport top
  document.addEventListener('mouseleave', e => {
    if (e.clientY < 0) showExitPopup();
  });

  // Mobile: show after 45s if user hasn't interacted with CTA
  if ('ontouchstart' in window) {
    setTimeout(() => {
      const purchased = document.querySelector('.cart-count-bubble');
      if (!purchased || purchased.textContent.trim() === '0') showExitPopup();
    }, 45000);
  }

  // ── HERO CHAT TEASER AUTO-ANIMATION ──
  const hctTeaser = document.getElementById('heroChatTeaser');
  if (hctTeaser) {
    setTimeout(() => { const u = document.getElementById('hctUser'); if (u) u.classList.add('visible'); }, 2200);
    setTimeout(() => { const t = document.getElementById('hctTyping'); if (t) t.classList.add('visible'); }, 3000);
    setTimeout(() => {
      const t = document.getElementById('hctTyping'); if (t) t.classList.remove('visible');
      const l = document.getElementById('hctLena'); if (l) l.classList.add('visible');
    }, 4800);
  }

}); // end DOMContentLoaded
